/* Sleep Collective — shared behaviour. Progressive enhancement only. */
window.scBrandInit = function () {
  "use strict";

  /* Sticky header shadow */
  var header = document.querySelector(".sc-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-stuck", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile nav */
  var burger = document.querySelector(".sc-burger");
  var nav = document.querySelector(".sc-nav");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        nav.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* Scroll reveals with stagger */
  var items = document.querySelectorAll(".sc-reveal");
  if (!items.length) return;
  if (!("IntersectionObserver" in window)) {
    items.forEach(function (el) { el.classList.add("is-in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute("data-sc-delay") || "0", 10);
      setTimeout(function () { el.classList.add("is-in"); }, delay);
      io.unobserve(el);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  items.forEach(function (el) { io.observe(el); });

  /* Auto-stagger siblings inside a grid */
  document.querySelectorAll("[data-sc-stagger]").forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      if (child.classList.contains("sc-reveal") && !child.hasAttribute("data-sc-delay")) {
        child.setAttribute("data-sc-delay", String(i * 90));
      }
    });
  });
};
window.scBrandInit();

/* Keep the footer copyright year current. */
document.querySelectorAll("[data-sc-year]").forEach(function (el) {
  el.textContent = String(new Date().getFullYear());
});


/* Theme Editor support: re-run the enhancers when a section is re-rendered. */
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    if (typeof window.scBrandInit === 'function') { window.scBrandInit(); }
    document.querySelectorAll('[data-sc-year]').forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });
  });
}
